import UserOperatorListRequest, {
  UserOperatorListRequestStatusCriteria,
  UserOperatorListRequestOrder,
} from "../../../../api/raily/user/operator/list/user-operator-list.request";
import UserOrder from "../../../../types/user-order";
import UserStatus from "../../../../types/user-status";
import paginationService from "../../../../utils/pagination/pagination.service";
import UserOperatorListParams from "./user-operator-list-params";

const createStatusCriteria = (
  status: UserStatus | undefined,
): UserOperatorListRequestStatusCriteria => {
  switch (status) {
    case UserStatus.ACTIVE:
      return UserOperatorListRequestStatusCriteria.ACTIVE;
    case UserStatus.DELETED:
      return UserOperatorListRequestStatusCriteria.DELETED;
    default:
      return UserOperatorListRequestStatusCriteria.ALL;
  }
};

const createOrder = (
  status: UserOrder | undefined,
): UserOperatorListRequestOrder | undefined => {
  switch (status) {
    case UserOrder.FIRST_NAME_ASC:
      return UserOperatorListRequestOrder.FIRST_NAME_ASC;
    case UserOrder.FIRST_NAME_DESC:
      return UserOperatorListRequestOrder.FIRST_NAME_DESC;
    case UserOrder.LAST_NAME_ASC:
      return UserOperatorListRequestOrder.LAST_NAME_ASC;
    case UserOrder.LAST_NAME_DESC:
      return UserOperatorListRequestOrder.LAST_NAME_DESC;
    case UserOrder.USERNAME_ASC:
      return UserOperatorListRequestOrder.USERNAME_ASC;
    case UserOrder.USERNAME_DESC:
      return UserOperatorListRequestOrder.USERNAME_DESC;
    default:
      return undefined;
  }
};

const create = (params: UserOperatorListParams): UserOperatorListRequest => {
  return {
    creationStart: params.creationDateFrom,
    creationEnd: params.creationDateTo,
    email: params.email,
    firstName: params.firstName,
    lastName: params.lastName,
    limit: params.pageSize,
    offset: paginationService.calculateOffset(params.page, params.pageSize),
    order: createOrder(params.order),
    statusCriteria: createStatusCriteria(params.status),
    username: params.username,
  };
};

const userOperatorListParamsFactory = { create };

export default userOperatorListParamsFactory;
